<nav class="sidebar" [class.compact]="isCompact()">
  <mat-nav-list>
    <a mat-list-item routerLink="/traites" routerLinkActive="active-item"
       [matTooltip]="isCompact() ? 'Traités juridiques' : ''"
       matTooltipPosition="right">
      <mat-icon matListItemIcon>description</mat-icon>
      @if (!isCompact()) { <span matListItemTitle>Traités juridiques</span> }
    </a>
    <a mat-list-item routerLink="/marques" routerLinkActive="active-item"
       [matTooltip]="isCompact() ? 'Marques' : ''"
       matTooltipPosition="right">
      <mat-icon matListItemIcon>business</mat-icon>
      @if (!isCompact()) { <span matListItemTitle>Marques</span> }
    </a>
    <a mat-list-item routerLink="/audit" routerLinkActive="active-item"
       [matTooltip]="isCompact() ? 'Historique' : ''"
       matTooltipPosition="right">
      <mat-icon matListItemIcon>history</mat-icon>
      @if (!isCompact()) { <span matListItemTitle>Historique</span> }
    </a>
    @if (userCtx.isAdmin) {
      <a mat-list-item routerLink="/configuration" routerLinkActive="active-item"
         [matTooltip]="isCompact() ? 'Configuration' : ''"
         matTooltipPosition="right">
        <mat-icon matListItemIcon>settings</mat-icon>
        @if (!isCompact()) { <span matListItemTitle>Configuration</span> }
      </a>
    }
  </mat-nav-list>
</nav>
